import { render, staticRenderFns } from "./QuickReport.vue?vue&type=template&id=2a81fdc0&scoped=true&"
import script from "./QuickReport.vue?vue&type=script&lang=js&"
export * from "./QuickReport.vue?vue&type=script&lang=js&"
import style0 from "./QuickReport.vue?vue&type=style&index=0&id=2a81fdc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81fdc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBottomSheet,VBtn,VCard,VIcon,VProgressCircular,VProgressLinear})
